export enum EditMode {
  View,
  Add,
  Edit
}

export enum FileStatus {
  Empty = 'Empty',
  Collected = 'Collected',
  Uploading = 'Uploading',
  Processing = 'Processing',//s3 uploaded but not processed, no garbage can, cannot delete
  Uploaded = 'Uploaded',//in bronze, garbage can, can delete
  Error = 'Error'
}

export enum SnapshotStatus {
  BronzeCollecting = 'BRONZE_COLLECTING',
  BronzeCollcted = 'BRONZE_COLLECTED',
  BronzeCollectError = 'BRONZE_COLLECT_ERROR',
  BronzeIngesting = 'BRONZE_INGESTING',
  BronzeIngested = 'BRONZE_INGESTED',
  BronzeIngestError = 'BRONZE_INGEST_ERROR',
  SilverTransforming = 'SILVER_TRANSFORMING',
  SilverTransformError = 'SILVER_TRANSFORM_ERROR',
  SilverTransformed = 'SILVER_TRANSFORMED',
  GoldTransforming= 'GOLD_TRANSFORMING',
  GoldTransformErrror = 'GOLD_TRANSFORM_ERROR',
  GoldTransformed = 'GOLD_TRANSFORMED'
}


export enum SnapshotV2Status {
    WAITING = 'WAITING',
    INGESTING_BRONZE = 'INGESTING_BRONZE',
    BRONZE_COMPLETE = 'BRONZE_COMPLETE',
    PROCESSING_SILVER = 'PROCESSING_SILVER',
    SILVER_COMPLETE = 'SILVER_COMPLETE',
    PROCESSING_GOLD = 'PROCESSING_GOLD',
    GOLD_COMPLETE = 'GOLD_COMPLETE',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_WARNINGS = 'COMPLETED_WITH_WARNINGS',
    FAILED_WITH_ERRORS = 'FAILED_WITH_ERRORS',
}

export enum MfaMode {
  ScanQrCode,
  Authenticate
}

export enum AuthChallange {
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  MfaRequired = 'MFA_REQUIRED',
  MfaSetup = 'MFA_SETUP',
  PasswordResetRequired = 'PASSWORD_RESET_REQUIRED',
  CustomChallenge = 'CUSTOM_CHALLENGE',
  ChangePassword = 'CHANGE_PASSWORD',
  ChangeEmail = 'CHANGE_EMAIL',
  VerifyEmail = 'VERIFY_EMAIL',
  VerifyPhone = 'VERIFY_PHONE',
  VerifyAttribute = 'VERIFY_ATTRIBUTE',
  VerifyLogin = 'VERIFY_LOGIN',
  VerifyMfa = 'VERIFY_MFA',
  VerifySoftware = 'VERIFY_SOFTWARE',
  VerifyHardware = 'VERIFY_HARDWARE',
  VerifyDevice = 'VERIFY_DEVICE',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
  MFAFailure = 'MFA_FAILURE',
  NotHandled = 'NOT_HANDLED',
  TotpRequired = 'TOTP_REQUIRED',
  selectMFAType = 'SELECT_MFA_TYPE',
  associateSoftwareToken = 'ASSOCIATE_SOFTWARE_TOKEN',
  Login= 'LOGIN',
  SessionExpired = 'SESSION_EXPIRED'
}